import { createMuiTheme } from '@material-ui/core';

import palette from './palette';
import typography from './typography';
import typeGraphyLarge from './typography_large';
import overrides from './overrides';

let finalTypography = typography
const fontSize = localStorage.getItem("fontSize")

switch (fontSize) {
  case "large": {
    finalTypography = typeGraphyLarge
    break
  }
  default: {
    finalTypography = typography
    break
  }
}

const theme = createMuiTheme({
  palette,
  typography: finalTypography,
  overrides,
});

export default theme;
